<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>

<div id="questionLists" class="col-md-10 mt-5">
  <div class="col-md-8"></div>
  <!-- Cards Row -->
  <app-news-and-current-affairs></app-news-and-current-affairs>
</div>
